import Cookies from 'js-cookie'

const accessToken = '__access_token'
const pmAccessToken = '__pm_access_token'

// 修复 cookie 跨域问题

export function getAccessToken () {
  return Cookies.get(accessToken)
}

export function setAccessToken (token) {
  return Cookies.set(accessToken, token)
}

export function removeAccessToken () {
  return Cookies.remove(accessToken)
}

export function getPmAccessToken () {
  return Cookies.get(pmAccessToken)
}

export function setPmAccessToken (token) {
  return Cookies.set(pmAccessToken, token)
}

export function removePmAccessToken () {
  return Cookies.remove(pmAccessToken)
}